module.exports = __webpack_public_path__ + "static/portfolio-mas-13-e5ccfe9dcf20720ab679bd7ad6088d69.jpg";